import { Box, Typography } from '@mui/material';
import { MapPin } from 'lucide-react';

const statusLabels = {
  'in-progress': 'En curso',
  completed: 'Completada',
};

function InitiativeHero({ initiative }) {
  if (!initiative) return null;
  const {
    name,
    subtitle,
    heroImage,
    heroImageAlt,
    summary,
    location,
    status,
  } = initiative;

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: '0.95fr 1.05fr' },
        gap: { xs: 3, sm: 4, md: 6 },
        alignItems: 'center',
        mb: { xs: 5, sm: 7, md: 9 },
      }}
    >
      {heroImage && (
        <Box
          sx={{
            width: '100%',
            mx: { xs: 'auto', md: 0 },
            maxWidth: { xs: 360, md: '100%' },
            position: 'relative',
          }}
        >
          <Box
            component="img"
            src={heroImage}
            alt={heroImageAlt || name}
            sx={{
              width: '100%',
              aspectRatio: { xs: '4/5', md: '5/6' },
              objectFit: 'cover',
              borderRadius: 4,
              boxShadow: '0 18px 50px rgba(74, 106, 74, 0.18)',
              border: '1px solid rgba(74, 106, 74, 0.12)',
            }}
          />
        </Box>
      )}

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 1.25, sm: 1.75 }, textAlign: { xs: 'center', md: 'left' }, alignItems: { xs: 'center', md: 'flex-start' } }}>
        {subtitle && (
          <Typography
            variant="overline"
            sx={{
              color: 'primary.main',
              letterSpacing: '0.18em',
              fontWeight: 600,
              fontSize: { xs: '0.7rem', sm: '0.78rem' },
            }}
          >
            {subtitle}
          </Typography>
        )}
        <Typography
          component="h1"
          sx={{
            fontFamily: 'var(--font-heading)',
            color: 'text.primary',
            fontSize: 'clamp(2.4rem, 7vw, 4rem)',
            fontWeight: 500,
            lineHeight: 1.05,
            letterSpacing: '-0.01em',
          }}
        >
          {name}
        </Typography>
        {status && (
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 1,
              px: 1.5,
              py: 0.5,
              mt: 0.5,
              borderRadius: 999,
              backgroundColor: 'rgba(74, 106, 74, 0.1)',
              color: 'primary.dark',
              fontSize: '0.75rem',
              fontWeight: 600,
              letterSpacing: '0.04em',
              textTransform: 'uppercase',
            }}
          >
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: status === 'completed' ? 'primary.main' : '#d98c3a',
              }}
            />
            {statusLabels[status] || status}
          </Box>
        )}
        {summary && (
          <Typography
            sx={{
              color: 'text.secondary',
              fontSize: { xs: '1rem', sm: '1.1rem', md: '1.15rem' },
              lineHeight: 1.6,
              maxWidth: '34rem',
              mt: 1,
            }}
          >
            {summary}
          </Typography>
        )}
        {location?.name && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              color: 'text.secondary',
              mt: 1,
            }}
          >
            <MapPin size={16} color="#4a6a4a" />
            <Typography sx={{ fontSize: '0.9rem' }}>
              {[location.name, location.region].filter(Boolean).join(' · ')}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default InitiativeHero;
